import React, { createContext, useContext, useState, ReactNode } from 'react';

interface ModalContextType {
  showAuthModal: boolean;
  modalContext: 'checkout' | 'general';
  openAuthModal: (context?: 'checkout' | 'general') => void;
  closeAuthModal: () => void;
}

const ModalContext = createContext<ModalContextType | undefined>(undefined);

export const useModal = () => {
  const context = useContext(ModalContext);
  if (!context) {
    throw new Error('useModal debe ser usado dentro de ModalProvider');
  }
  return context;
};

interface ModalProviderProps {
  children: ReactNode;
}

export const ModalProvider: React.FC<ModalProviderProps> = ({ children }) => {
  const [showAuthModal, setShowAuthModal] = useState(false);
  const [modalContext, setModalContext] = useState<'checkout' | 'general'>('general');

  const openAuthModal = (context: 'checkout' | 'general' = 'general') => {
    setModalContext(context);
    setShowAuthModal(true);
  };
  
  const closeAuthModal = () => {
    setShowAuthModal(false);
    setModalContext('general');
  };

  const value: ModalContextType = {
    showAuthModal,
    modalContext,
    openAuthModal,
    closeAuthModal,
  };

  return (
    <ModalContext.Provider value={value}>
      {children}
    </ModalContext.Provider>
  );
}; 